// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTAStatus } from './dta-status';
import {
    DTAStatusFromJSON,
    DTAStatusFromJSONTyped,
    DTAStatusToJSON,
    DTAStatusToJSONTyped,
} from './dta-status';
import type { SourceType } from './source-type';
import {
    SourceTypeFromJSON,
    SourceTypeFromJSONTyped,
    SourceTypeToJSON,
    SourceTypeToJSONTyped,
} from './source-type';
import type { WorkflowStage } from './workflow-stage';
import {
    WorkflowStageFromJSON,
    WorkflowStageFromJSONTyped,
    WorkflowStageToJSON,
    WorkflowStageToJSONTyped,
} from './workflow-stage';

/**
 * 
 * @export
 * @interface DTARecord
 */
export interface DTARecord {
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    approved_at?: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    approved_by?: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    data_stream_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DTARecord
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    dta_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    ingestion_spec_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    last_modified_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    last_modified_by: string;
    /**
     * 
     * @type {boolean}
     * @memberof DTARecord
     */
    locked: boolean;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    rejection_reason?: string;
    /**
     * 
     * @type {SourceType}
     * @memberof DTARecord
     */
    source_type?: SourceType;
    /**
     * 
     * @type {DTAStatus}
     * @memberof DTARecord
     */
    status: DTAStatus;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    vendor_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof DTARecord
     */
    version: string;
    /**
     * 
     * @type {WorkflowStage}
     * @memberof DTARecord
     */
    workflow_stage: WorkflowStage;
}



/**
 * Check if a given object implements the DTARecord interface.
 */
export function instanceOfDTARecord(value: object): value is DTARecord {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('last_modified_at' in value) || value['last_modified_at'] === undefined) return false;
    if (!('last_modified_by' in value) || value['last_modified_by'] === undefined) return false;
    if (!('locked' in value) || value['locked'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    if (!('vendor_id' in value) || value['vendor_id'] === undefined) return false;
    if (!('vendor_name' in value) || value['vendor_name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function DTARecordFromJSON(json: any): DTARecord {
    return DTARecordFromJSONTyped(json, false);
}

export function DTARecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTARecord {
    if (json == null) {
        return json;
    }
    return {
        
        'approved_at': json['approved_at'] == null ? undefined : json['approved_at'],
        'approved_by': json['approved_by'] == null ? undefined : json['approved_by'],
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'data_stream_id': json['data_stream_id'] == null ? undefined : json['data_stream_id'],
        'domains': json['domains'],
        'dta_id': json['dta_id'],
        'ingestion_spec_id': json['ingestion_spec_id'] == null ? undefined : json['ingestion_spec_id'],
        'last_modified_at': json['last_modified_at'],
        'last_modified_by': json['last_modified_by'],
        'locked': json['locked'],
        'rejection_reason': json['rejection_reason'] == null ? undefined : json['rejection_reason'],
        'source_type': json['source_type'] == null ? undefined : SourceTypeFromJSON(json['source_type']),
        'status': DTAStatusFromJSON(json['status']),
        'study_id': json['study_id'],
        'vendor_id': json['vendor_id'],
        'vendor_name': json['vendor_name'],
        'version': json['version'],
        'workflow_stage': WorkflowStageFromJSON(json['workflow_stage']),
    };
}

export function DTARecordToJSON(json: any): DTARecord {
    return DTARecordToJSONTyped(json, false);
}

export function DTARecordToJSONTyped(value?: DTARecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approved_at': value['approved_at'],
        'approved_by': value['approved_by'],
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'data_stream_id': value['data_stream_id'],
        'domains': value['domains'],
        'dta_id': value['dta_id'],
        'ingestion_spec_id': value['ingestion_spec_id'],
        'last_modified_at': value['last_modified_at'],
        'last_modified_by': value['last_modified_by'],
        'locked': value['locked'],
        'rejection_reason': value['rejection_reason'],
        'source_type': SourceTypeToJSON(value['source_type']),
        'status': DTAStatusToJSON(value['status']),
        'study_id': value['study_id'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'version': value['version'],
        'workflow_stage': WorkflowStageToJSON(value['workflow_stage']),
    };
}
